import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'

import { type CustomField } from './CustomField'

export class CustomFieldRow extends RowBase<CustomField> {
  constructor(origin: CustomField) {
    super(origin)
    makeObservableRowBase(this)
  }

  get name() {
    return this.origin.name
  }

  get fieldType() {
    return this.origin.type
  }

  get fieldKey() {
    return this.origin.key
  }

  get visible() {
    return this.origin.visible
  }

  get editable() {
    return this.origin.editable
  }

  get isCustom() {
    return this.origin.isCustom
  }

  get isUsed() {
    return this.origin.is_used
  }

  get apiId() {
    return this.origin.apiId
  }
}
